"use strict";

var _objectSpread = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encodeBlock = exports.decodeBlock = exports.encodeTransaction = exports.decodeTransaction = exports.decodeAccount = exports.getTransactionAssetSchema = void 0;

var lisk_codec_1 = require("@liskhq/lisk-codec");

var lisk_cryptography_1 = require("@liskhq/lisk-cryptography");

var getTransactionAssetSchema = function getTransactionAssetSchema(transaction, registeredSchema) {
  var txAssetSchema = registeredSchema.transactionsAssets.find(function (assetSchema) {
    return assetSchema.moduleID === transaction.moduleID && assetSchema.assetID === transaction.assetID;
  });

  if (!txAssetSchema) {
    throw new Error("ModuleID: ".concat(transaction.moduleID, " AssetID: ").concat(transaction.assetID, " is not registered."));
  }

  return txAssetSchema.schema;
};

exports.getTransactionAssetSchema = getTransactionAssetSchema;

var decodeAccount = function decodeAccount(encodedAccount, registeredSchema) {
  return lisk_codec_1.codec.decode(registeredSchema.account, encodedAccount);
};

exports.decodeAccount = decodeAccount;

var decodeTransaction = function decodeTransaction(encodedTransaction, registeredSchema) {
  var transaction = lisk_codec_1.codec.decode(registeredSchema.transaction, encodedTransaction);
  var assetSchema = exports.getTransactionAssetSchema(transaction, registeredSchema);
  var asset = lisk_codec_1.codec.decode(assetSchema, transaction.asset);
  var id = lisk_cryptography_1.hash(encodedTransaction);
  return _objectSpread({}, transaction, {
    asset: asset,
    id: id
  });
};

exports.decodeTransaction = decodeTransaction;

var encodeTransaction = function encodeTransaction(transaction, registeredSchema) {
  var assetSchema = exports.getTransactionAssetSchema(transaction, registeredSchema);
  var encodedAsset = lisk_codec_1.codec.encode(assetSchema, transaction.asset);
  var decodedTransaction = lisk_codec_1.codec.encode(registeredSchema.transaction, _objectSpread({}, transaction, {
    asset: encodedAsset
  }));
  return decodedTransaction;
};

exports.encodeTransaction = encodeTransaction;

var decodeBlock = function decodeBlock(encodedBlock, registeredSchema) {
  var block = lisk_codec_1.codec.decode(registeredSchema.block, encodedBlock);
  var header = lisk_codec_1.codec.decode(registeredSchema.blockHeader, block.header);
  var id = lisk_cryptography_1.hash(block.header);
  var assetSchema = registeredSchema.blockHeadersAssets[header.version];

  if (!assetSchema) {
    throw new Error("Block header asset version ".concat(header.version, " is not registered."));
  }

  var asset = lisk_codec_1.codec.decode(assetSchema, header.asset);
  var payload = [];

  var _iterator = _createForOfIteratorHelper(block.payload),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var tx = _step.value;
      payload.push(exports.decodeTransaction(tx, registeredSchema));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return {
    header: _objectSpread({}, header, {
      asset: asset,
      id: id
    }),
    payload: payload
  };
};

exports.decodeBlock = decodeBlock;

var encodeBlock = function encodeBlock(block, registeredSchema) {
  var encodedPayload = block.payload.map(function (p) {
    return exports.encodeTransaction(p, registeredSchema);
  });
  var assetSchema = registeredSchema.blockHeadersAssets[block.header.version];

  if (!assetSchema) {
    throw new Error("Block header asset version ".concat(block.header.version, " is not registered."));
  }

  var encodedBlockAsset = lisk_codec_1.codec.encode(assetSchema, block.header.asset);
  var encodedBlockHeader = lisk_codec_1.codec.encode(registeredSchema.blockHeader, _objectSpread({}, block.header, {
    asset: encodedBlockAsset
  }));
  return lisk_codec_1.codec.encode(registeredSchema.block, {
    header: encodedBlockHeader,
    payload: encodedPayload
  });
};

exports.encodeBlock = encodeBlock;